import { render, staticRenderFns } from "./order-inquiry.vue?vue&type=template&id=b6b8ecba&scoped=true&"
import script from "./order-inquiry.vue?vue&type=script&lang=js&"
export * from "./order-inquiry.vue?vue&type=script&lang=js&"
import style0 from "./order-inquiry.vue?vue&type=style&index=0&id=b6b8ecba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b8ecba",
  null
  
)

export default component.exports